export const year = "2025-26";
export const isCurrent = false;

export const coreSlices = [];

export const core = [];

export const teams = [];
